export default __webpack_public_path__ + "static/media/back.82efdf8e.svg";